<template>
  <div class="general">
    <h4>{{ $t('graphs.general') }}</h4>

    <div class="general-wrapper">
      <div class="general-item">
        <canvas :id="chart.id"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'GeneralGraph',
  // eslint-disable-next-line vue/require-prop-types
  props: ['period'],

  data() {
    return {
      chart: {
        id: 'general',
        type: 'line',
        chart: [],
        opt2: [],
        opt1: [],
        labels: [],
      },
    }
  },

  mounted() {
    this.$watch('period', this.fetch, { deep: true, immediate: true })
  },

  methods: {
    fetch() {
      this.$uiBlocker(
        this.$http
          .get('charts/bookingsInfo', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data)
          }),
        this.$el,
      )
    },
    draw(data) {
      let ctx = document.getElementById(this.chart.id).getContext('2d')

      this.setOptions(data)

      let graph = this.chart.chart

      if (Object.keys(graph).length !== 0) {
        graph.destroy()
      }

      this.createLineGraph(ctx)
    },

    setOptions(data) {
      this.chart.labels = Object.keys(data.total)
      this.chart.opt1 = Object.values(data.total)
      this.chart.opt2 = Object.values(data.cancelled)
    },

    createLineGraph(ctx) {
      this.chart.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chart.labels,
          datasets: [
            {
              label: this.$t('graphs.total'),
              fill: false,
              lineTension: 0.1,
              backgroundColor: 'rgba(225,0,0,0.4)',
              borderColor: 'blue',
              borderCapStyle: 'square',
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: 'black',
              pointBackgroundColor: 'white',
              pointBorderWidth: 1,
              pointHoverRadius: 8,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              pointHitRadius: 10,
              data: this.chart.opt1,
              spanGaps: true,
            },
            {
              label: this.$t('graphs.canceled'),
              fill: false,
              lineTension: 0.1,
              borderColor: 'red',
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: 'white',
              pointBorderWidth: 1,
              pointHoverRadius: 8,
              pointHoverBorderWidth: 2,
              pointRadius: 4,
              pointHitRadius: 10,
              data: this.chart.opt2,
              spanGaps: true,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      })
    },
  },
}
</script>

<style scoped>
h4 {
  margin-top: 20px;
}

.general-item {
  min-height: 300px;
}
</style>
